import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, palette, spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
var FloatingActionMenu = styled.div.withConfig({
  componentId: "sc-1p0mtu-0"
})(["display:inline-flex;align-items:center;height:60px;border-radius:", ";background-color:", ";padding:0 ", ";color:", ";"], radius("round"), palette("surface"), spacing("sm"), palette("neutral.900"));
export { FloatingActionMenu };